// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container.aboutTextSec {
  margin: auto;
  padding-right: 0;
  max-width: 1140px;
}

.aboutWrap {
  padding-right: 0;
  overflow: hidden;
  background: #f4f4f4;
}

.imgContent {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
}

.imgContent > div {
  float: none;
}

.iqvia-formerly-quin {
  font-size: 16px;
  display: block;
  height: 100%;
  align-content: center;
  background: transparent;
  border: none;
  min-height: 494px;
  margin-bottom: 25px;
}

.op-kphase-1-site {
  display: flex;
  align-items: stretch;
  margin-top: -15px;
}

.op-kphase-1-site #siteImage {
  height: 100%;
  object-fit: contain;
}

.margin-auto {
  margin: 0 auto;
}

.notification-container {
  position: absolute;
  z-index: 100;
  background-color: #43B02A;
  margin: 0 20%;
  font-size: 13pt;
  color: #fff;
}

span[name=close-notification] {
  position: absolute;
  right: -20px;
  top: -30px;
  font-size: 20pt;
  color: #534949;
}

.close-notification:hover {
  opacity: 0.8;
}

span[name=notification-icon] {
  font-size: xx-large;
  position: absolute;
  top: -20px;
  color: #ffcd0c;
  text-shadow: 5px 5px 10px #4b4112;
}

.notification-bell {
  position: absolute;
  right: -0.5%;
  top: 2%;
  padding: 10px;
}

  .notification-bell:hover {
    text-shadow: 4px 6px 2px #0b87cb;
    border: 1px double #ffcd0c;
  }

  .notification-bell i {
    color: #ffcd0c;
    font-size: xx-large;
  }
`, "",{"version":3,"sources":["webpack://./src/app/participant/participant_home/participant_home.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,aAAa;AACf;;EAEE;IACE,gCAAgC;IAChC,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB","sourcesContent":[".container.aboutTextSec {\r\n  margin: auto;\r\n  padding-right: 0;\r\n  max-width: 1140px;\r\n}\r\n\r\n.aboutWrap {\r\n  padding-right: 0;\r\n  overflow: hidden;\r\n  background: #f4f4f4;\r\n}\r\n\r\n.imgContent {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: stretch;\r\n}\r\n\r\n.imgContent > div {\r\n  float: none;\r\n}\r\n\r\n.iqvia-formerly-quin {\r\n  font-size: 16px;\r\n  display: block;\r\n  height: 100%;\r\n  align-content: center;\r\n  background: transparent;\r\n  border: none;\r\n  min-height: 494px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.op-kphase-1-site {\r\n  display: flex;\r\n  align-items: stretch;\r\n  margin-top: -15px;\r\n}\r\n\r\n.op-kphase-1-site #siteImage {\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.margin-auto {\r\n  margin: 0 auto;\r\n}\r\n\r\n.notification-container {\r\n  position: absolute;\r\n  z-index: 100;\r\n  background-color: #43B02A;\r\n  margin: 0 20%;\r\n  font-size: 13pt;\r\n  color: #fff;\r\n}\r\n\r\nspan[name=close-notification] {\r\n  position: absolute;\r\n  right: -20px;\r\n  top: -30px;\r\n  font-size: 20pt;\r\n  color: #534949;\r\n}\r\n\r\n.close-notification:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\nspan[name=notification-icon] {\r\n  font-size: xx-large;\r\n  position: absolute;\r\n  top: -20px;\r\n  color: #ffcd0c;\r\n  text-shadow: 5px 5px 10px #4b4112;\r\n}\r\n\r\n.notification-bell {\r\n  position: absolute;\r\n  right: -0.5%;\r\n  top: 2%;\r\n  padding: 10px;\r\n}\r\n\r\n  .notification-bell:hover {\r\n    text-shadow: 4px 6px 2px #0b87cb;\r\n    border: 1px double #ffcd0c;\r\n  }\r\n\r\n  .notification-bell i {\r\n    color: #ffcd0c;\r\n    font-size: xx-large;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
